export default __webpack_public_path__ + "static/manageHouses-75380ae87360c28bc9d454a75c13454f.png";